import { Box, Typography, Modal, TextField, Button } from '@mui/material';
import propTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { removeAccents } from '../helpers';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%', // Cambiado el ancho a un valor relativo
  maxWidth: 400, // Agregado un máximo ancho para el modal
  background: 'rgba(255, 255, 255, 1)',
  border: '2px solid #ccc', // Cambiado el color del borde
  borderRadius: 8,
  boxShadow: 24,
  p: 4,
  m: 0, // Eliminado el margen para que el modal esté más cerca del centro
};

export default function ModalPrice({
  modalOpen,
  setModalOpen,
  templates,
  updateBicInParentComponent,
  priceBICUtility,
}) {
  const [objectBicToUpdate, setObjectBicToUpdate] = useState();
  useEffect(() => {
    filterAndSetBicToUpdate();
  }, [modalOpen]);

  const handleClose = () => {
    if (objectBicToUpdate !== '') {
      updateBicInParentComponent(objectBicToUpdate);
    }
    setModalOpen(false);
  };

  const handleCloseWithOutSave = () => {
    filterAndSetBicToUpdate();
    setModalOpen(false);
  };

  const handleInputChange = (e, object, index) => {
    let input = e.target.value;
    if (!input) input = 0;
    // accedemos al indice del array y corroboramos que el templateName coincida, si es asi se asigna el valor del input
    if (objectBicToUpdate.utility[index].templateName === object.templateName) {
      objectBicToUpdate.utility[index].templatePrice = parseFloat(input);
    }
    setObjectBicToUpdate({ ...objectBicToUpdate });
  };

  const filterAndSetBicToUpdate = () => {
    // asignamos los valores a objectBicToUpdate (de esta forma si hay cambios pero el usuario se arrepiente
    // no se modifica los valores en el objeto original: priceBICUtility)
    if (priceBICUtility && !objectBicToUpdate && modalOpen) {
      const auxPriceBICUtility = JSON.parse(JSON.stringify(priceBICUtility));
      // eslint-disable-next-line no-undef
      const idRecordatorio = JSON.parse(localStorage.getItem('idRecordatorio'));
      const filteredUtility = auxPriceBICUtility.utility.filter((object) => {
        const isAllowedTemplateName =
          removeAccents(object.templateName) === removeAccents('Alta de paciente') ||
          removeAccents(object.templateName) === removeAccents('Activación de chat') ||
          removeAccents(object.templateName) === 'confirmacion/cancelacion';

        const hasConfirmationCancellation = auxPriceBICUtility.utility.some(
          (obj) => removeAccents(obj.templateName) === 'confirmacion/cancelacion',
        );
        const isNewReminderTemplate =
          !hasConfirmationCancellation &&
          !isAllowedTemplateName &&
          idRecordatorio === object.templateId;

        if (isNewReminderTemplate) {
          object.templateName = 'confirmacion/cancelacion';
        }
        return isAllowedTemplateName || isNewReminderTemplate;
      });
      auxPriceBICUtility.utility = filteredUtility;
      setObjectBicToUpdate(auxPriceBICUtility);
    }
  };
  return (
    <Modal
      open={modalOpen}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Typography variant="h6">Setee los precios de BIC Utility</Typography>
        {objectBicToUpdate &&
          objectBicToUpdate.utility?.map((object, index) => {
            return (
              <TextField
                sx={{ mt: 2, ml: 3, width: '80%' }}
                key={index}
                id="outlined-basic"
                value={object.templatePrice || null}
                label={`BIC Utility: ${
                  removeAccents(object.templateName) === 'confirmacion/cancelacion'
                    ? 'recordatorios'
                    : object.templateName
                }`}
                type="number"
                variant="outlined"
                onChange={(event) => handleInputChange(event, object, index)}
              />
            );
          })}
        <Box sx={{ mt: 2, display: 'flex', justifyContent: 'space-between' }}>
          <Button onClick={handleClose}>Guardar</Button>
          <Button onClick={handleCloseWithOutSave}>Cerrar sin guardar</Button>
        </Box>
      </Box>
    </Modal>
  );
}

const Props = {
  modalOpen: propTypes.bool,
  setModalOpen: propTypes.bool,
  templates: propTypes.array,
  updateBicInParentComponent: propTypes.func,
  priceBICUtility: propTypes.object,
};

ModalPrice.propTypes = Props;
